(function () {
  function initGallery(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = root.querySelectorAll('[data-thumb]');
    var index = 0;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + index * -100 + '%)';
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
      if (thumbs[index]) thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      Array.prototype.forEach.call(slides, function (s, n) {
        var v = s.querySelector('video');
        if (v && n !== index) v.pause();
      });
    }

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(Number(t.dataset.thumb)); });
    });

    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      startX = null;
    });

    document.addEventListener('rv:variant', function (e) {
      var img = e.detail && e.detail.mediaId;
      if (!img) return;
      Array.prototype.forEach.call(slides, function (s, n) {
        if (s.dataset.mediaId === String(img)) go(n);
      });
    });
  }

  function initProduct(root) {
    var offers = root.querySelectorAll('[data-offer]');
    var form = root.querySelector('[data-rv-form]');
    var idInput = root.querySelector('[data-rv-id]');
    var button = root.querySelector('[data-rv-add]');
    var errorBox = root.querySelector('[data-rv-error]');

    function activeOffer() {
      return root.querySelector('[data-offer].is-active') || offers[0];
    }

    function select(offer) {
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var first = offer.querySelector('[data-row-select]');
      if (first && idInput) idInput.value = first.value;
    }

    offers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        select(o);
      });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o); }
      });
      o.querySelectorAll('[data-row-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var opt = sel.options[sel.selectedIndex];
          var img = sel.parentElement.querySelector('[data-row-img]');
          if (img && opt.dataset.img) img.src = opt.dataset.img;
          if (idInput && sel === o.querySelector('[data-row-select]')) idInput.value = sel.value;
        });
      });
    });

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var offer = activeOffer();
      var qty = offer ? Number(offer.dataset.qty || 1) : 1;
      var items = [];
      var selects = offer ? offer.querySelectorAll('[data-row-select]') : [];
      if (selects.length) {
        var counts = {};
        selects.forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
        Object.keys(counts).forEach(function (id) { items.push({ id: Number(id), quantity: counts[id] }); });
      } else {
        items.push({ id: Number(idInput.value), quantity: qty });
      }
      if (offer && offer.dataset.gift) items.push({ id: Number(offer.dataset.gift), quantity: 1 });
      if (offer && offer.dataset.gifts) offer.dataset.gifts.split(',').filter(Boolean).forEach(function (id) { items.push({ id: Number(id), quantity: 1 }); });

      button.disabled = true;
      if (errorBox) errorBox.hidden = true;

      addToDrawer(items)
        .catch(function (err) {
          if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
        })
        .finally(function () { button.disabled = false; });
    });

    var sticky = root.querySelector('[data-rv-sticky]');
    if (sticky && button && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }).observe(button);
    }
  }

  function initReviews(root) {
    var more = root.querySelector('[data-more]');
    if (!more) return;
    var step = Number(root.dataset.step || 5);
    more.addEventListener('click', function () {
      var hidden = root.querySelectorAll('.rv-review[hidden]');
      for (var i = 0; i < step && i < hidden.length; i++) hidden[i].hidden = false;
      if (hidden.length <= step) more.hidden = true;
    });
  }

  function initSlider(root) {
    var track = root.querySelector('.rv-slider__track');
    root.querySelectorAll('[data-slide]').forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: Number(b.dataset.slide) * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }


  function addToDrawer(items) {
    var drawer = document.querySelector('cart-drawer');
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
        if (drawer && res.data.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.data);
        } else {
          window.location.href = root + 'cart';
        }
        return res.data;
      });
  }
  window.rvAddToDrawer = addToDrawer;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cartx-add]');
    if (!btn) return;
    var item = btn.closest('.rv-cartx__item');
    var sel = item && item.querySelector('[data-cartx-variant]');
    btn.disabled = true;
    addToDrawer([{ id: Number(sel ? sel.value : btn.dataset.cartxAdd), quantity: 1 }])
      .catch(function () { btn.textContent = 'Nicht verfügbar'; })
      .finally(function () { btn.disabled = false; });
  });

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-cartx-protect]');
    if (!box || !box.checked) return;
    box.disabled = true;
    addToDrawer([{ id: Number(box.dataset.cartxProtect), quantity: 1 }]).catch(function () { box.checked = false; box.disabled = false; });
  });

  function init(scope) {
    scope.querySelectorAll('[data-rv-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-rv-product]').forEach(initProduct);
    scope.querySelectorAll('[data-rv-reviews]').forEach(initReviews);
    scope.querySelectorAll('[data-rv-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
